import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';
import OtherCandidate from './OtherCandidate';

import { getStatewideDisplay} from '../election-utils';

const converter = PreactHTMLConverter();

class Contest extends Component {
  constructor() {
    super();

    this.state = { 
      viewAllDemocraticCandidates: true,
      viewAllRepublicanCandidates: true, 
    };
    this.onViewableToggle = this.onViewableToggle.bind(this);
  }

  onViewableToggle(party) {
    if (party === 'democrat') {
      this.setState(prevState => ({
        viewAllDemocraticCandidates: !prevState.viewAllDemocraticCandidates, // set viewAllCandidates to what is wasn't before
      }));
    }

    if (party === 'republican') {
      this.setState(prevState => ({
        viewAllRepublicanCandidates: !prevState.viewAllRepublicanCandidates, // set viewAllCandidates to what is wasn't before
      }));
    }
  };

  render(
    { ballot, flag, notes, statewideRace, visibleCandidateCount, renderCandidate}, 
    { viewAllDemocraticCandidates, viewAllRepublicanCandidates }
  ) {

    const democrat = ballot.filter(
      candidate => candidate.party == 'Democratic'
    );
    const republican = ballot.filter(
      candidate => candidate.party == 'Republican'
    );

    console.log(viewAllDemocraticCandidates)
    console.log(viewAllRepublicanCandidates)

   

    const caption =  getStatewideDisplay(ballot)

    const IsFlagged = (flag) ? true : false;
    const IsNoted= (notes) ? true : false;

    const IsDemocrat = (democrat.length > 0) ? true : false;
    const IsRepublican = (republican.length > 0) ? true : false;

    return (
      <div class="seat">
         {statewideRace && (
            <h3 class="seat__title">{caption}</h3>
          )}
        
        {IsFlagged == true && (
          <div class="seat__flag">
            <p class="office__flag">
              <span class="gold-star">★</span>Race to watch
            </p>
            <p class="seat__flag__text">{converter.convert(flag)}</p></div>
        )}
        <div class="seat__races">
          {IsDemocrat == true && (
            <div class="seat__race seat__race--Democrat">
              <div class="race">
                <h4 class="race__title">Democrat</h4>
                <table class="race__candidates">
                  <thead>
                    <tr>
                      {' '}
                      <th
                        scope="col"
                        class="race__candidate-header"
                        colspan="2"
                      >
                        Candidates{' '}
                      </th>{' '}
                    </tr>
                  </thead>
                  <tbody>
                    {democrat.map((candidate: any, idx: any) =>
                      renderCandidate(candidate, idx, viewAllDemocraticCandidates)
                    )}
                    {democrat.length > visibleCandidateCount && (
                      <OtherCandidate
                        isViewable={!viewAllDemocraticCandidates}
                        candidateCount={democrat.length - visibleCandidateCount}
                        onClick={() => { this.onViewableToggle('democrat') }}
                      /> )}
                  </tbody>

                  {/* Take out the ! before viewAllDemocraticCandidates to add toggle for more candidates back and change viewAllDemocraticCandidates to false */}
                  {democrat.length > visibleCandidateCount && !viewAllDemocraticCandidates && (
                    <tr
                        class="candidate race__candidate-row">
                      <td
                        class="candidate__cell candidate__party t-align-center"
                        onClick={() => { this.onViewableToggle('democrat') }}
                      >
                        <svg class="icon icon-angle-up">
                          <use xlinkHref="#icon-angle-up" />
                        </svg>
                      </td>
                      <th class="candidate__cell candidate__name">
                        <button onClick={() => { this.onViewableToggle('democrat') }}>
                          Show fewer candidates{' '}
                        </button>
                      </th>
                    </tr>
                  )}
                </table>
              </div>
            </div>
          )}

          {IsRepublican == true && (
            <div class="seat__race seat__race--Republican">
              <div class="race">
                <h4 class="race__title">Republican</h4>
                <table class="race__candidates">
                  <thead>
                    <tr>
                      {' '}
                      <th
                       
                        scope="col"
                        class="race__candidate-header"
                        colspan="2"
                      
                      >
                        Candidates{' '}
                      </th>{' '}
                    </tr>
                  </thead>
                  <tbody>
                    {republican.map((candidate: any, idx: any) =>
                      renderCandidate(candidate, idx, viewAllRepublicanCandidates)
                    )}
                    {republican.length > visibleCandidateCount && (
                      <OtherCandidate
                        isViewable={!viewAllRepublicanCandidates}
                        candidateCount={republican.length - visibleCandidateCount}
                        onClick={() => { this.onViewableToggle('republican') }}
                      /> )}
                  </tbody>
                  {/* Take out the ! before viewAllRepublicanCandidates to add toggle for more candidates back and change viewAllRepublicanCandidates to false */}
                  {republican.length > visibleCandidateCount && !viewAllRepublicanCandidates && (
                    <tr
                        class="candidate race__candidate-row">
                      <td
                        class="candidate__cell candidate__party t-align-center"
                        onClick={() => { this.onViewableToggle('republican') }}
                      
                      >
                        <svg class="icon icon-angle-up">
                          <use xlinkHref="#icon-angle-up" />
                        </svg>
                      </td>
                      <th class="candidate__cell candidate__name">
                        <button onClick={() => { this.onViewableToggle('republican') }}>
                          Show fewer candidates{' '}
                        </button>
                      </th>
                    </tr>
                  )}
                </table>
              </div>
            </div>
          )}
        </div>

        {IsNoted == true && !statewideRace && (
          <p class="note__text">{converter.convert(notes)}</p>
        )}

        {IsNoted == true && statewideRace && (
          <p class="note__text">{converter.convert(notes.value)}</p>
        )}
      </div>
    );
  }
}

Contest.defaultProps = {
  statewideRace: false,
  visibleCandidateCount: 4,
};

export default Contest;
